export class Payment {
  guaranteeType?: string;
  deposit?: number;
  creditCard?: {
    type?: string;
    name?: string;
    token?: string;
    cvv?: string;
    expirationDate?: string;
  };
  constructor() {}
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/model/reservation/payment.model.ts